export default "/directory/static/photo_album_available.ad8d8601.svg";